module.exports = __webpack_public_path__ + "static/media/full-screen.3c418fcf.svg";